import { useState } from "react";

interface CustomImageProps {
  src: string;
  alt?: string;
  width?: number;
  height?: number;
  style?: object;
  className?: string;
}

export const CustomImage = (props: CustomImageProps) => {
  const [hideImage, setHideHImage] = useState(false);

  // TODO: get better onError and blurDataURL images from design
  if (hideImage) {
    return <></>;
  } else {
    return (
      <img
        alt=""
        {...props}
        src={props.src}
        onError={() => {
          setHideHImage(true);
        }}
      />
    );
  }
};
